import { repositories } from '../api/createRepositories';

const usageRepository = repositories.usage;

export const usageService = {
  getCharacterStats: async (start_unix, end_unix, options = {}) => {
    return await usageRepository.getCharacterStats(start_unix, end_unix, options);
  }
};

export const { getCharacterStats } = usageService;

export default usageService;